import { render, staticRenderFns } from "./LandingPageIndex.vue?vue&type=template&id=3ec5c7b2&"
import script from "./LandingPageIndex.vue?vue&type=script&lang=js&"
export * from "./LandingPageIndex.vue?vue&type=script&lang=js&"
import style0 from "./LandingPageIndex.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports